const style = {
  container: {
    border: `1px solid #666`
  },
  input: {
    background: `white`,
    color: `black`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Application/Main/style/ColorBlind/form.js